
import {Later} from 'utils/timers'

export default {
  props: {
    suggestion: {type: [String, Object], required: true}
  },
  emits: ['ask-ai'],
  data() {
    return {
      hover: false,
      expand: new Later(500),
    }
  },
  computed: {
    string() {
      return typeof this.suggestion === 'string' 
    },
    text(){
      if (this.string) return this.suggestion
      if (this.suggestion.agent === 'genrate') return 'Ask Genrate'
      return this.suggestion.text
    }
  },
  methods: {
    onMouseEnter() {
      this.expand.abort()
      this.hover = true
    },
    onMouseLeave() {
      this.expand.abort()
      this.expand.once(() => this.hover = false)
    },
  }
}
